import styled from "styled-components";

export const TncHeader = styled.div`
display: flex;
flex-direction: column;
justify-content: flex-start;
  position: sticky;
color: #000;
font-family: "Open Sans", sans-serif;
font-size: 14px;
font-style: normal;
font-weight: 400;
line-height: 19.6px; 
  top: 0;
  left: 0;
  width: 100%;
  background: white;
  padding: 20px;
  border-bottom: 1px #cdcdcd solid;
  margin-bottom: 24px;

  & h1{
color: #000;

font-family: "Ubuntu",sans-serif;
font-size:36px;
font-style: normal;
font-weight: 400;
line-height: 44px;
letter-spacing: -0.72px;
margin-bottom: 20px;
  }

  & button{
    position: absolute;
    top:15px;
    right:15px;
  }
`;

export const TncWrapper = styled.div`
  position: relative;
  overflow: auto;
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  &::-webkit-scrollbar {
    width: 0;
    background: transparent;
  }
`;

export const TncActionsWrapper = styled.div`
  position: sticky;
  color: #015294;
  bottom: 0;
  left: 0;
  width: 100%;
`;

export const TncActions = styled.div`
  background: white;
  display: flex;
  width: 100%;
  justify-content: end;
  padding: 20px;
  background-color: #eeebeb;
  border-top: 1px solid #cdcdcd;
`;

export const TnCButton = styled.button`
  border: 1px solid #015294;
  background: #ffffff;
  padding: 8px 16px;
  color: #015294;
  cursor: pointer;
  border-radius: 10000px;
`;

export const TnCData = styled.div`
padding: 20px 46px;
    width: 100%;

  & h2,
  & h3,
  & h4,
  & ul,
  & ol {
    all: revert;
  }
`;